import { spacingMixin } from "@zillow/constellation";
import PropTypes from "prop-types";
import styled from "styled-components";
import customPropTypes from "../../utils/custom-prop-types.esm.js";
const IframeWithAspectRatio = styled.iframe.withConfig({
  displayName: "ResponsiveIframe__IframeWithAspectRatio",
  componentId: "sc-m9v0q7-0"
})(["aspect-ratio:", ";max-width:100%;width:", "px;height:100%;", ""], (props) => `${props.width} / ${props.height}`, (props) => props.width, spacingMixin);
IframeWithAspectRatio.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  margin: customPropTypes.inlineMediaQuery(PropTypes.shape({
    marginTop: PropTypes.string,
    marginRight: PropTypes.string,
    marginLeft: PropTypes.string,
    marginBottom: PropTypes.string
  }))
};
IframeWithAspectRatio.defaultProps = {};
export {
  IframeWithAspectRatio as default
};
